import styled, { css } from 'styled-components';

import { type TooltipAlignment, type TooltipVariant } from '@pkg/components';

interface TooltipStyleProps {
    $variant?: TooltipVariant;
    $alignment?: TooltipAlignment;
    $maxWidth?: number;
}
export const TooltipWrapper = styled.div<TooltipStyleProps>`
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid transparent;
    z-index: 201; // TODO find out why
    outline: none;
    ${({ $variant }) => {
        switch ($variant) {
            case 'secondary': {
                return css`
                    width: max-content;
                    max-width: 320px;
                    margin-bottom: 10px;
                `;
            }
            case 'wrapper': {
                return css`
                    width: fit-content;
                    border: none;
                `;
            }
            case 'primary': {
                return css`
                    width: 320px;
                `;
            }
        }
    }};
`;

export const TooltipBorder = styled.div<TooltipStyleProps>`
    padding: 1px;
    position: relative;

    ${({ $variant }) => {
        switch ($variant) {
            case 'secondary': {
                return css`
                    border-radius: 12px;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #324c64 100%);
                    box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5);
                `;
            }
            case 'wrapper': {
                return css`
                    padding: 0;
                    background: none;
                `;
            }
            case 'primary':
            default: {
                return css`
                    border-radius: 22px;
                    background: linear-gradient(
                        310deg,
                        rgba(100, 100, 109, 1) 0%,
                        rgba(26, 25, 38, 1) 50%,
                        rgba(100, 100, 109, 1) 100%
                    );
                `;
            }
        }
    }};
`;

export const Content = styled.div<TooltipStyleProps>`
    position: relative;
    box-sizing: border-box;
    font-style: normal;
    color: #fff;

    text-align: ${({ $alignment }) => ($alignment === 'center' ? 'center' : 'flex-start')};
    align-items: ${({ $alignment }) => ($alignment === 'center' ? 'center' : 'flex-start')};
    flex-direction: column;
    display: inherit;

    background: radial-gradient(113.75% 307.5% at 36.25% 32.5%, rgba(29, 27, 43, 0.9) 0%, rgba(9, 7, 25, 0.9) 100%)
        #090719;
    padding: 22px;
    border-radius: 22px;
    letter-spacing: -0.3px;
    line-height: 120%;
    font-weight: 400;
    font-size: 16px;
    width: fit-content;
    max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : '100%')};

    ${({ $variant }) => {
        switch ($variant) {
            case 'secondary': {
                return css`
                    background: radial-gradient(100% 100% at 50.18% 0%, #212654 0%, #221f46 27.81%, #1a2025 100%);
                    padding: 10px 15px;
                    border-radius: 12px;
                    font-weight: 600;
                    font-size: 12px;
                    line-height: 16px;
                    letter-spacing: -0.02em;
                    flex-direction: column;

                    display: flex;
                `;
            }
            case 'wrapper': {
                // TODO - find a better way to style action
                //  - this variant is only used for the Legacy Tooltip right now
                return css`
                    width: unset;
                    background: unset;
                    padding: unset;
                    border-radius: unset;
                    border: unset;
                    display: unset;
                    position: unset;
                `;
            }
            case 'primary': {
                return css`
                    display: flex;
                `;
            }
            default: {
                return css`
                    display: inherit;
                `;
            }
        }
    }};
`;

export const PopoverAction = styled.span<TooltipStyleProps>`
    cursor: pointer;
    ${({ $variant }) => {
        switch ($variant) {
            case 'wrapper': {
                // TODO - find a better way to style action
                //  - this variant is only used for the Legacy Tooltip right now
                return css`
                    position: relative;
                    top: -35px;
                    left: 15px;
                    font-size: 13px;
                    font-weight: bold;
                `;
            }
            case 'secondary':
            case 'primary': {
                return css`
                    display: flex;
                    margin-top: 8px;
                    font-family: 'Alliance No.1', sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 12px;
                    line-height: 100%;
                    text-align: center;
                    letter-spacing: -0.02em;
                    color: white;

                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 40px;
                    padding: 10px 40px;
                    border: none;

                    &:hover {
                        background: rgba(255, 255, 255, 0.3);
                    }
                `;
            }
            default: {
                return css``;
            }
        }
    }};
`;
